import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";
import { Typography } from "@/components/ui/typography";
import { homeRoute } from "../routes";
import { useTranslation } from "react-i18next";

export const Profile = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-4">
      <div className="flex h-full flex-col gap-4 self-stretch text-center">
        <Typography tag="h1">{t("general.profile")}</Typography>
        <Typography tag="p" className="text-muted-foreground">
          {t("general.thisIsYourProfilePage")}
        </Typography>
        <Link to={homeRoute}>
          <Button variant="outline">{t("general.back")}</Button>
        </Link>
      </div>
    </div>
  );
};
